import { render } from "./DealerOrders.vue?vue&type=template&id=5c3357d4"
import script from "./DealerOrders.vue?vue&type=script&lang=js"
export * from "./DealerOrders.vue?vue&type=script&lang=js"

import "./DealerOrders.vue?vue&type=style&index=0&id=5c3357d4&lang=css"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__